import { render, staticRenderFns } from "./IntegrationWebhook.vue?vue&type=template&id=2471ca40&lang=pug&"
import script from "./IntegrationWebhook.vue?vue&type=script&lang=js&"
export * from "./IntegrationWebhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports